import * as React from "react";
import { useParams, Link, useHistory } from "react-router-dom";

//styles

import EdButton from "../../../generic/edButton";
import { IftPayoutStatusResponse, IftTransHistObj, IErrorHandler } from "../../../types/components/fundTransfer/ftTypes";
import { toINR } from "../../../service/numberFormat";
import { AddRemClass } from "../../../helper/addRemoveClsOfTgt";
import FtFundsModal, { ftStatsIcon } from "./ftModal";
import { FtCircledIcon } from "../generic/ftCircleOIcon";
import { useQuery } from "../../../service/urlHelper";
import { ftFormValidate } from "../generic/ftFormValidation";
import indexer, { jwtToken } from "../../../types/genericTypes";
import { AFTModifyPayout, AFTCancelPayout } from "../../../service/fundTransfer/fundTransferApiService";
import { CANCEL_T_RECORD } from "../../../generic/cancel_T_Record";
import { FtInpField } from "../generic/ftInpField";
import { parsedToken } from "../../../service/storageHelper";
import { Idevice } from "../../../types/device";
import DeviceContext from "../../../service/indentifyDevice";
import { FTRegex } from "../ftConstants";

export interface IFtModalPayOutProps {}

/**** add payout acknowledgment container start ******/
function FtPayOutStat(ftresponse: IftPayoutStatusResponse) {
	return (
		<>
			{ftresponse && (
				<div className={"ftModalBody  taCenter mg-t20 withdrawStat"}>
					{/* icon */}
					<FtCircledIcon style={{ width: "125px", height: "125px" }} icon={<i className={ftStatsIcon["800"] + " icon"}></i>} />
					{/* message */}
					<>
						<p className="ftStatusMsg mg-t25">Request Received</p>
						<p className="ftTransferdesc">We shall notify you once the request has been processed.</p>
					</>
					{FtTransferDetails(ftresponse)}
					<p className="mg-t25 showDetls">
						<EdButton
							value="Show details"
							btnTyp="blue-link"
							className="showDetls"
							onClick={() => {
								AddRemClass(true, "#ftRespDetails", "show");
							}}
						/>
					</p>
					<div className="ftStatDetails">{FtRedirectList(ftresponse)}</div>
				</div>
			)}
		</>
	);
}
//deatils of the transaction like bank name, amount etc.,
export function FtTransferDetails(ftresponse: IftPayoutStatusResponse) {
	return (
		<div className="ftStatDetails ftTglDetails" id="ftRespDetails">
			<ul className="transactDetails">
				<li>
					<label className="lbl">Amt Transferred:</label>
					<label className="val">₹{toINR(ftresponse.trnsAmt, 2)}</label>
				</li>

				<li>
					<label className="lbl">A/C No.</label>
					<label className="val">{ftresponse.bnkAccNo}</label>
				</li>
				<li>
					<label className="lbl">Bank Name:</label>
					<label className="val">{ftresponse.bnkName}</label>
				</li>
			</ul>
		</div>
	);
}
// list of redirections after success full transaction
export function FtRedirectList(ftresponse: IftPayoutStatusResponse) {
	const pToken: jwtToken | null = parsedToken();

	return (
		<ul className="ftRedirectLinks taLeft">
			<li>
				<Link to="../add-funds">
					<span>Transfer More Funds</span>
					<i className="icon edel-icon-arrow-right"></i>
				</Link>
			</li>
			<li>
				<Link
					to={
						"../history/" +
						(ftresponse.accType
							? ftresponse.accType.toLowerCase()
							: pToken && pToken.accType === "COMEQ"
							? "eq"
							: pToken && pToken.accType.toLowerCase()) +
						"/withdrawn"
					}
				>
					<span>Show history</span>
					<i className="icon edel-icon-arrow-right"></i>
				</Link>
			</li>
		</ul>
	);
}
/**** add payout acknowledgment container end ******/

/**** edit layout ****/
function FtEditWithdrawAmt(transaction: IftTransHistObj) {
	let history = useHistory();

	//type of device tablet/mobile/desktop
	const handleDevice: Idevice = DeviceContext();
	//error messages associated with input field amt
	const editAmtErrMsgs: indexer = {
		min: "Please enter valid amount",
		max: `Amount can’t be more than ${toINR(transaction.lim, 2)}`,
		required: "Please enter the amount to proceed"
	};
	//form fields constructed object
	// let EditForm: indexer = {
	// 	editamt: transaction.trnsAmt
	// };

	const [editAmt, setEditAmt] = React.useState("");
	//message dispatcher to show error messages
	const [message, dispatchMsg] = React.useState<Array<string>>([editAmtErrMsgs["max"]]);

	//hold the form field input values
	function getFormValuesByField(_key: string, value: any) {
		setEditAmt(value);
	}
	//api call to inital modify transaction of the payout
	//error response will be handled in the page itself,
	//on success response will redirect to request received page
	function ModifySuccessCallBack(res: any) {
		const editAmtInp: HTMLElement = document.getElementsByName("editamt")[0];
		if (res.data) {
			editAmtInp.dataset["error"] = "false";

			const url = "/fund-transfer/withdraw-funds/status?status=" + JSON.stringify({ ...transaction, trnsAmt: editAmt });

			history.push(url);
		} else if (res.error) {
			dispatchMsg([res.error.errMsg]);
			editAmtInp.dataset["error"] = "true";
		}
	}
	return (
		<div className="blk" style={{ minHeight: "calc(" + window.innerHeight + "px - 60px)" }}>
			{/* additional div used to keep the contents vertically middle aligned */}
			<div className="blkCont taCenter">
				<p className="hdg">Edit Withdrawal Amount</p>
				<form
					name="editForm"
					onSubmit={(e) => {
						e.preventDefault();
						let eTar = e.target as any,
							eTarElements: Array<any> = eTar.elements;
						let validationstatus: IErrorHandler = { ErrorState: false, key: "" };
						for (let i = 0; i < eTarElements.length; i++) {
							const element: HTMLElement = eTarElements[i] as HTMLElement;
							if (element.nodeName === "INPUT") {
								validationstatus = ftFormValidate(element);
								dispatchMsg([editAmtErrMsgs[validationstatus.key]]);
							}
						}
						if (!validationstatus.ErrorState) {
							dispatchMsg([editAmtErrMsgs["max"]]);
							AFTModifyPayout(
								ModifySuccessCallBack,
								{ rmk: transaction.rmk, instNo: transaction.instNo, amt: editAmt },
								transaction.accType
							);
						}
					}}
					noValidate
				>
					<FtInpField
						value={editAmt}
						clsNm="mg-t15 editAmt ph_lh"
						min={1}
						max={parseFloat(transaction.lim)}
						autoFocus={true}
						type={!handleDevice.isMobile ? "text" : "number"}
						showProxyField={true}
						vr="normal"
						ph="Eg: 10,000"
						name="editamt"
						pattern={FTRegex.mobAmt}
						regEx={FTRegex.amt}
						validation={{
							min: 1,
							max: parseFloat(transaction.lim),
							required: true
						}}
						label=""
						error={editAmtErrMsgs}
						info={message[0]}
						proxy_inp="proxy"
						validateOnChange={true}
						onChange={getFormValuesByField}
					/>
					<EdButton type="submit" className="mg-t40 editConfrimBtn" btnTyp="primary" value="Confirm" />
				</form>
			</div>
		</div>
	);
}

export function FTCancelPayout(transaction: IftTransHistObj) {
	let history = useHistory();

	const [message, dispatchMsg] = React.useState<string>("");
	const [cancelClicked, setCancelClicked] = React.useState<boolean>(false);
	function confirmCancel() {
		setCancelClicked(true);

		AFTCancelPayout(cancelCallback, { instNo: transaction.instNo }, transaction.accType);
	}

	function cancelCallback(res: any) {
		setCancelClicked(false);

		const pToken: jwtToken | null = parsedToken();
		if (res.data) {
			history.push(
				"/fund-transfer/history/" + (pToken && pToken.accType === "COMEQ" ? "eq" : pToken && pToken.accType.toLowerCase()) + "/withdrawn"
			);
			dispatchMsg("");
		} else {
			dispatchMsg(res.error.errMsg);
		}
	}
	return (
		<div className="blk" style={{ minHeight: "calc(" + window.innerHeight + "px - 60px)" }}>
			{/* additional div used to keep the contents vertically middle aligned */}
			<div className="blkCont taCenter">
				<CANCEL_T_RECORD
					title="Cancel Transaction"
					subtitle="Are you sure you want to cancel your fund transfer?"
					btnProps={{ value: "Yes, Confirm", btnTyp: "secondary", onClick: confirmCancel, disabled: cancelClicked }}
				/>
				<p className="errorMsg mg-t10">{message}</p>
			</div>
		</div>
	);
}
export default function FtModalPayOut(_props: IFtModalPayOutProps) {
	const { state } = useParams<{ state: string }>();

	const query = useQuery();
	let history = useHistory();
	const pToken: jwtToken | null = parsedToken();

	const payoutReqReceviedState: IftPayoutStatusResponse = JSON.parse(
			"" + (state && ((query.get(state) as unknown) as IftPayoutStatusResponse)) + ""
		),
		payoutTransState = JSON.parse("" + (state && ((query.get(state) as unknown) as IftTransHistObj)) + "");
	let linktoHist = "/fund-transfer/history/" + (pToken?.accType === "COMEQ" ? "eq" : pToken?.accType.toLowerCase()) + "/withdrawn";
	if (state === "edit" && payoutTransState) {
		linktoHist = "/fund-transfer/history/" + payoutTransState.accType.toLowerCase() + "/withdrawn";
	}

	window.history.pushState({}, "", window.location.href.split("?")[0]);
	!payoutTransState && history.push(linktoHist);
	return (
		<section className="ftSection">
			<div className={`ftPayoutModal payOutCont ${state?.toLowerCase()}`}>
				{payoutTransState && (
					<>
						{state && state === "status" ? (
							<FtFundsModal
								status={FtPayOutStat(payoutReqReceviedState)}
								showLogo={true}
								showFooter={true}
								closeLink={"/fund-transfer/history/" + payoutReqReceviedState.accType.toLowerCase() + "/withdrawn"}
							/>
						) : state && state === "edit" && payoutTransState.edit === "true" ? (
							<FtFundsModal status={FtEditWithdrawAmt(payoutTransState)} showLogo={false} showFooter={false} closeLink={linktoHist} />
						) : (
							state &&
							state === "cancel" &&
							payoutTransState.cancel === "true" && (
								<FtFundsModal
									status={FTCancelPayout(payoutTransState)}
									showLogo={false}
									showFooter={false}
									closeLink={"/fund-transfer/history/" + payoutReqReceviedState.accType.toLowerCase() + "/withdrawn"}
								/>
							)
						)}
					</>
				)}
			</div>
		</section>
	);
}
